module.exports = {
  join: {
    key: 'join',
    label: 'Join',
  },
  recordingStarted: {
    key: 'recordingStarted',
    label: 'Recording Started',
  },
};